import React from 'react';
import { createRoot } from "react-dom/client";
import {BrowserRouter as Router} from 'react-router-dom';
import {Provider} from 'react-redux';
import store from '../redux/store';
import history from '../helpers/history';
import {dynamicImport} from '../helpers/common';


const ListingsInfiniteScroll = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "ListingsInfiniteScroll" */ '../components/ListingsInfiniteScroll'));


if (document.getElementById('sch-listings-container')) {
    const school_id = document.getElementsByName('school_id')[0].value;
    const school_subdomain = document.getElementsByName('school_subdomain')[0].value;

    const root = document.getElementById('sch-listings-container');
    createRoot(root).render(<Provider store={store}>
        <Router history={history}>
            <ListingsInfiniteScroll
                school_subdomain={school_subdomain}
                school_id={school_id}
                history={history} />
        </Router>
    </Provider>);
}

window.addEventListener('DOMContentLoaded', (event) => {
    handlePropertyClick();
});

function propertyClickEventListener(event) {
    if (!event.target?.href) {
        var a = event.target.querySelector("a");
        if (typeof a !== typeof undefined) {
            if (a?.href?.length) {
                window.location = a.href;
            }
        }
    }
}

function handlePropertyClick() {
    const properties = document.querySelectorAll(".property")
    for (const property of properties) {
        property.removeEventListener('click', propertyClickEventListener);
        property.addEventListener('click', propertyClickEventListener)
    }
}
window.handlePropertyClick = handlePropertyClick;

